module.exports = __webpack_public_path__ + "static/media/Artboard28.e3ed7015.png";